import { createSelector } from 'reselect';
import { getVersions } from '@Selectors/builder/myArmyList/common/selector';
import { VersionGameView } from './view/VersionGameView';
import { Version } from '@Models';
import { VersionView } from './view/VersionView';

export const uniqueSource = (
  value: VersionGameView,
  index: number,
  self: Array<VersionGameView>,
): boolean => {
  return self.findIndex((i) => i.game == value.game) === index;
};

const buildVersionGameViews = (versions: Version[]): VersionGameView[] => {
  return versions
    .map(
      (version) =>
        new VersionGameView({
          label: `activerecord.attributes.ninth_age_version.game.${version.game}`,
          game: version.game,
          options: new Array<VersionView>(),
        }),
    )
    .filter(uniqueSource)
    .map((versionGame) => {
      versionGame.options = versions
        .filter((version) => version.game === versionGame.game)
        .map(
          (version) =>
            new VersionView({
              id: version.id,
              name: version.name,
              game: version.game,
            }),
        );

      return versionGame;
    });
};

export const VersionGamePresenter = createSelector(
  [getVersions],
  (versions): VersionGameView[] => {
    return buildVersionGameViews(versions);
  },
);
